import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RepayDigitalWalletPage } from './repay-digital-wallet.page';

const routes: Routes = [
  {
    path: '',
    component: RepayDigitalWalletPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RepayDigitalWalletPageRoutingModule {} 